module.exports = __webpack_public_path__ + "img/bg_sake.93017a94.jpg";